import { POS_INFINITY, ToNumber } from "@pdfking/math"
import type { Atom } from "@pdfking/tfunc"
import { AtomHash, RandomFloat } from "@pdfking/tfunc"

export type RandomStream = () => number

// A stream of numbers in [0, 1) seeded by `salt`: the same salt always draws
// the same numbers, any difference in it draws unrelated ones
export const CreateRandom = (...salt: Atom[]): RandomStream => {
  const stream = RandomFloat(POS_INFINITY, 0, 1, ToNumber(AtomHash(salt) % 0x100000000n))
  return () => stream.next().value!
}
